import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import {FieldOptionType} from 'appRedux/actions/forms/types';

import FormFieldOptionMetadataForm from 'components/Forms/FormBuilder/FieldForm/partialsMetadataOptions/FormFieldOptionMetadataForm';

interface OptionsMetadataListType {
    isDisabled: boolean;
    options: FieldOptionType[];
}

const OptionsMetadataList: FC<OptionsMetadataListType> = ({options, isDisabled}) => {
    const [t] = useTranslation();
    return (
        <Box sx={{mt: 2, mb: 1}}>
            <Typography sx={{fontWeight: 700}}>{`${t('orguser.forms.formField.optionsVariables')}:`}</Typography>
            {options &&
                options.map((option: FieldOptionType, index: number) => {
                    return (
                        <Box key={`option-${option.uuid}`}>
                            <FormFieldOptionMetadataForm option={option} keyIndex={index} isDisabled={isDisabled} />
                        </Box>
                    );
                })}
        </Box>
    );
};

export default OptionsMetadataList;
